module.exports = __webpack_public_path__ + "59fd3060dc8e1775e7ae064cd70fb211.svg";